import type { ReactNode } from 'react';
import AnimatedInteraction from 'components/atomic/atoms/animated-interaction';
import { bentoTokens } from '../bento-tokens';

/**
 * Renders the "See All" button with consistent styling and positioning
 * 
 * @param seeAllSlot - Function that returns the See All button component
 * @param total - Total number of images
 * @returns ReactNode or null if seeAllSlot is not provided
 */
export function renderSeeAllButton(
  seeAllSlot: ((total: number) => ReactNode) | undefined,
  total: number
): ReactNode {
  if (!seeAllSlot) return null;
  
  return (
    <AnimatedInteraction
      sx={{
        position: 'absolute',
        bottom: bentoTokens.overlay.seeAll,
        right: bentoTokens.overlay.seeAll,
        zIndex: bentoTokens.zIndex.seeAll,
      }}
    >
      {seeAllSlot(total)}
    </AnimatedInteraction>
  );
}
